import React from 'react';

import {HealthGuide} from 'presentation/modules/guide/health/ui/pages/HealthGuide';

export const MakeHealthGuide: React.FC = () => {
	return <HealthGuide />;
};
